import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { PencilIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const EditIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  ({ tooltipTitle, ...props }, ref) => {
    const { t } = useTranslation();
    const resolvedTooltipTitle = tooltipTitle ?? t('common.edit', 'Edit');

    return (
      <IconButton
        ref={ref}
        {...props}
        tooltipTitle={resolvedTooltipTitle}
      >
        <PencilIcon color="inherit" fontSize={props.fontSize} />
      </IconButton>
    );
  },
);

EditIconButton.displayName = 'EditIconButton';
export default EditIconButton;
